import ReturnTutorialCwalk from '../../components/ReturnTutorialCwalk';

export default function ReturnTutorial() {
    return (
      <div>
        <ReturnTutorialCwalk />
      </div>
    )
  }